import TypographyPrimary from 'components/Typography/Primary'
import styled from 'styled-components'
import { StyledTypographyWrapper } from './TwitterCard'

const PostCard = ({ text, link }: { text: string; link: string }) => {
    let url = null
    try {
        url = new URL(link)
    } catch (error) {
        return null
    }

    return (
        <StyledCard onClick={() => window.open(link, '_blank')}>
            <StyledHeader>
                <StyledLogo src={`//f7.allesedv.com/16/${url?.hostname}`} alt='' />

                <StyledTypographyWrapper onClick={() => window.open(url.origin, '_blank')}>
                    <TypographyPrimary value={url?.hostname} bold />
                </StyledTypographyWrapper>
            </StyledHeader>

            <StyledBody>
                <TypographyPrimary value={text} size='medium' />
            </StyledBody>
        </StyledCard>
    )
}

export default PostCard

export const StyledCard = styled.div`
    width: 100%;
    max-width: 800px;

    background: ${({ theme }) => theme.body.cardBgColor};
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    border-radius: 22px;
    padding: 20px;

    display: flex;
    flex-direction: column;

    cursor: pointer;
`
export const StyledHeader = styled.header`
    height: 30px;

    display: flex;
    align-items: center;
    gap: 4px;

    margin-bottom: 5px;
`

export const StyledBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`
export const StyledLogo = styled.img`
    height: 20px;
    width: 20px;

    object-fit: contain;

    border-radius: 10px;
`
